import React, { useContext } from 'react';

import { ApplicationUIContext, Table } from '@yuhuinc/ui-library';
import { Typography } from 'antd';

import currency from 'currency.js';

import { getTranslatedString } from 'helpers/i18n';

import { CurrentApplicationContext } from '../../ApplicationOverview';

const { Title } = Typography;

const COLUMNS = [
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.overview.rentableItemsSummary.name'
    ),
    dataIndex: 'name',
    width: '80%',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.overview.rentableItemsSummary.rent'
    ),
    dataIndex: 'rent',
    align: 'right',
    // TODO: We can use Intl.Number​Format to format currencies: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
    render: (value) => currency(value.cents, { fromCents: true }).format(),
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.overview.rentableItemsSummary.marketRent'
    ),
    dataIndex: 'market_rent',
    align: 'right',
    render: (value) => currency(value.cents, { fromCents: true }).format(),
  },
];

const RentableItemsSummary = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const application = useContext(CurrentApplicationContext);

  const rentableItemsSummary = [
    application.lease
      ? {
          id: `lease-${application.lease.id}`,
          name: getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.overview.rentableItemsSummary.unitRent'
          ),
          rent: application.lease.lease_pricing?.rent,
          market_rent: application.lease.market_rent,
        }
      : null,
    ...(application.lease?.lease_charges || []).map((leaseCharge) => ({
      id: `lease-charge-${leaseCharge.id}`,
      name: leaseCharge.item_type,
      rent: leaseCharge.amount,
      market_rent: leaseCharge.ancillary_item.market_amount,
    })),
  ].filter(Boolean);

  return (
    <>
      <Title level={isMobile ? 4 : 5}>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.overview.rentableItemsSummary'
        )}
      </Title>
      {application.lease ? (
        <Table
          size="small"
          hideActionAndSearch
          columns={COLUMNS}
          dataSource={rentableItemsSummary}
          rowKey={(record) => record.id}
          pagination={false}
        />
      ) : null}
    </>
  );
};

export default RentableItemsSummary;
